import React from "react";
import { Row, Col } from "react-bootstrap";
import { priceEUR, totalPrice } from "../../helper/functions";

const CartTotal = ({ cart }) => {
  return (
    <div>
      <Row className="align-center">
        <Col>
          <h6 className="mt-2">Delivery</h6>
        </Col>
        <Col>
          <div className="float-end mt-2 me-2">{priceEUR(5)}</div>
        </Col>
      </Row>
      <hr />
      <Row className="align-center">
        <Col>
          <h6 className="mt-2">
            <b>TOTAL</b>
          </h6>
        </Col>
        <Col>
          <div className="float-end mt-2 me-2">
            {priceEUR(totalPrice(cart))}
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default CartTotal;
